import { handleConnectWalletAlgo, handleContractNameAlgo, handleGetRemainedTokenCountAlgo } from './algorand'
import { handleAssetInfo, handleCheckWhitelisted, ipfsToHTTP, mintErrorTreatment } from './default'
import {
    handleConnectWallet,
    handleEstimateGasPrice,
    handleGetContractName,
    handleGetRemainedTokenCount,
    handleMint,
    handleMintAllowed,
} from './ethereum'
import { getNFTsWinter } from './winter'

export const networkUtils = {
    algorand: {
        handleConnectWallet: handleConnectWalletAlgo,
        handleGetContractName: handleContractNameAlgo,
        handleGetRemainedTokenCount: handleGetRemainedTokenCountAlgo,
    },
    ethereum: {
        handleConnectWallet,
        handleEstimateGasPrice,
        handleGetContractName,
        handleGetRemainedTokenCount,
        handleMintAllowed,
        handleMint,
    },
    polygon: {
        handleConnectWallet,
        handleEstimateGasPrice,
        handleGetContractName,
        handleGetRemainedTokenCount,
        handleMintAllowed,
        handleMint,
    },
}

export const winterUtils = {
    getNFTs: getNFTsWinter,
}

export const generalUtils = {
    mintErrorTreatment,
    handleCheckWhitelisted,
    handleAssetInfo,
}

export const conversionUtils = {
    ipfsToHTTP,
}
